<template>
  <div class="rule">
    <div class="rule_cont">
      <div class="rule_title">{{ $t('home.rule.title') }}</div>
      <div class="rule_list">
        <div class="rule_li">
          <div class="rule_li_num">01</div>
          <div class="rule_li_text">{{ $t('home.rule.text1') }}</div>
        </div>
        <div class="rule_li">
          <div class="rule_li_num">02</div>
          <div class="rule_li_text">{{ $t('home.rule.text2') }}</div>
        </div>
        <div class="rule_li">
          <div class="rule_li_num">03</div>
          <div class="rule_li_text">{{ $t('home.rule.text3') }}</div>
          <div class="rule_li_btn" @click="dialogVisible = true">{{ $t('home.rule.text3_btn') }}</div>
        </div>
        <div class="rule_li">
          <div class="rule_li_num">04</div>
          <div class="rule_li_text">{{ $t('home.rule.text4') }}</div>
        </div>
        <!-- <div class="rule_li width100">
          <div class="rule_li_num">05 <span>{{ $t('home.rule.text5') }}</span></div>
          <div class="rule_li_table">
            <div class="table_li">
              <div class="table_li_text bgcolor1 width1">{{ $t('home.rule.table.table1_text1') }}</div>
              <div class="table_li_text bgcolor1 width2">{{ $t('home.rule.table.table1_text2') }}</div>
              <div class="table_li_text bgcolor1 width2">{{ $t('home.rule.table.table1_text3') }}</div>
              <div class="table_li_text bgcolor1 width2">{{ $t('home.rule.table.table1_text4') }}</div>
              <div class="table_li_text bgcolor1 width2">{{ $t('home.rule.table.table1_text5') }}</div>
              <div class="table_li_text bgcolor1 width2">{{ $t('home.rule.table.table1_text6') }}</div>
            </div>
            <div class="table_li">
              <div class="table_li_text bgcolor1 width1">{{ $t('home.rule.table.table2_text1') }}</div>
              <div class="table_li_text bgcolor2 width2">{{ $t('home.rule.table.table2_text2') }}</div>
              <div class="table_li_text bgcolor2 width2">{{ $t('home.rule.table.table2_text3') }}</div>
              <div class="table_li_text bgcolor2 width2">{{ $t('home.rule.table.table2_text4') }}</div>
              <div class="table_li_text bgcolor2 width2">{{ $t('home.rule.table.table2_text5') }}</div>
              <div class="table_li_text bgcolor2 width2">{{ $t('home.rule.table.table2_text6') }}</div>
            </div>
            <div class="table_li">
              <div class="table_li_text bgcolor1 width1">{{ $t('home.rule.table.table3_text1') }}</div>
              <div class="table_li_text bgcolor2 width2">{{ $t('home.rule.table.table3_text2') }}</div>
              <div class="table_li_text bgcolor2 width2">{{ $t('home.rule.table.table3_text3') }}</div>
              <div class="table_li_text bgcolor2 width2">{{ $t('home.rule.table.table3_text4') }}</div>
              <div class="table_li_text bgcolor2 width2">{{ $t('home.rule.table.table3_text5') }}</div>
              <div class="table_li_text bgcolor2 width2">{{ $t('home.rule.table.table3_text6') }}</div>
            </div>
            <div class="table_li">
              <div class="table_li_text bgcolor1 width1">{{ $t('home.rule.table.table4_text1') }}</div>
              <div class="table_li_text bgcolor2 width2">{{ $t('home.rule.table.table4_text2') }}</div>
              <div class="table_li_text bgcolor2 width2">{{ $t('home.rule.table.table4_text3') }}</div>
              <div class="table_li_text bgcolor2 width2">{{ $t('home.rule.table.table4_text4') }}</div>
              <div class="table_li_text bgcolor2 width2">{{ $t('home.rule.table.table4_text5') }}</div>
              <div class="table_li_text bgcolor2 width2">{{ $t('home.rule.table.table4_text6') }}</div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
  <Teleport to="body">
    <el-dialog v-model="dialogVisible" align-center title="Tips" :width="(screenWidth < 1200 ? '90%' : 1000)" :show-close="false" draggable>
      <template #header="{ close, titleId }">
        <div class="dialog-header">
          <div :id="titleId">{{ $t('dialog5.title') }}</div>
          <div @click="close" class="icon"></div>
        </div>
      </template>
      <div class="dialog-content">
        <div class="dialog-title">{{ $t('dialog5.text1') }}</div>
        <div class="dialog-text">{{ $t('dialog5.text2') }}</div>
        <div class="dialog-title">{{ $t('dialog5.text3') }}</div>
        <div class="dialog-img">
          <img src="../assets/rule/dialog_img1.png" alt="">
        </div>
        <div class="dialog-title">{{ $t('dialog5.text4') }}</div>
        <div class="dialog-list">
          <ul>
            <li>{{ $t('dialog5.text5_1') }}</li>
            <li>{{ $t('dialog5.text5_2') }}</li>
            <li>{{ $t('dialog5.text5_3') }}</li>
            <li>{{ $t('dialog5.text5_4') }}</li>
            <li>{{ $t('dialog5.text5_5') }}</li>
            <li>{{ $t('dialog5.text5_6') }}</li>
            <li>{{ $t('dialog5.text5_7') }}</li>
          </ul>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <div class="confirm" @click="dialogVisible=false">{{ $t('dialog5.btn') }}</div>
        </div>
      </template>
    </el-dialog>
  </Teleport>
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref, onMounted ,computed } from "vue";
  import { useI18n } from "vue-i18n";
  import { useStore } from "vuex"
  export default defineComponent({
    name: 'rule',
    setup() {
      const { t, locale } = useI18n()
      const store = useStore()
      let lan = computed(() => store.state.lan)
      const dialogVisible = ref(false)
      const screenWidth = ref(1200)
      onMounted(() => {
        screenWidth.value = window.innerWidth;
      });
      return {
        lan,
        screenWidth,
        dialogVisible
      };
    }
  })
</script>

<style scoped lang="scss">
.rule {
  width: 1200px;
  padding: 6px;
  border-radius: 20px;
  margin: 0 auto 60px;
  box-sizing: border-box;
  background: linear-gradient(172.56deg, rgba(46, 81, 60, 0.8) -70.92%, rgba(46, 81, 60, 0.32) 129.41%);
  .rule_cont {
    width: 100%;
    height: 100%;
    padding: 30px;
    border-radius: 20px;
    box-sizing: border-box;
    background: linear-gradient(270.02deg, rgba(47, 67, 55, 0.48) 4.26%, rgba(46, 81, 60, 0.24) 99.98%);
    .rule_title {
      font-size: 30px;
      font-weight: 600;
      line-height: 40px;
      text-align: center;
      letter-spacing: 0.05em;
      color: rgba(3, 255, 145, 1);
    }
    .rule_list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .rule_li {
        height: auto;
        width: 270px;
        margin-top: 20px;
        padding: 12px 16px;
        border-radius: 30px;
        box-sizing: border-box;
        background: linear-gradient(179.41deg, rgba(47, 67, 55, 0.688) 0.42%, rgba(46, 81, 60, 0.2924) 102.07%);
        &.width100 {
          width: 100%;
        }
        .rule_li_num {
          font-size: 28px;
          font-weight: 700;
          line-height: 37px;
          margin-bottom: 2px;
          letter-spacing: 0em;
          color: rgba(43, 179, 106, 0.5);
          span {
            color: #fff;
            font-size: 14px;
            font-weight: 400;
            line-height: 19px;
            letter-spacing: 0em;
          }
        }
        .rule_li_text {
          color: #fff;
          font-size: 14px;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 0em;
        }
        .rule_li_btn {
          display: inline-block;
          color: #fff;
          cursor: pointer;
          font-size: 12px;
          font-weight: 400;
          margin-top: 10px;
          padding: 6px 10px;
          letter-spacing: 0em;
          border-radius: 60px;
          background: linear-gradient(271.98deg, #2AB36A 4.13%, rgba(104, 204, 79, 0.8) 114.86%);
        }
        .rule_li_table {
          width: 100%;
          .table_li {
            display: flex;
            margin-bottom: 4px;
            justify-content: space-between;
            .table_li_text {
              height: 32px;
              padding: 2px 5px;
              font-size: 12px;
              text-align: center;
              letter-spacing: 0em;
              align-items: center;
              display: inline-flex;
              box-sizing: border-box;
              justify-content: center;
            }
            .bgcolor1 {
              color: #fff;
              font-weight: 500;
              background: rgba(54, 63, 94, 1);
            }
            .bgcolor2 {
              font-weight: 400;
              color: rgba(255, 255, 255, 0.8);
              background: rgba(54, 63, 94, 0.5);
            }
            .width1 {
              width: 195px;
            }
            .width2 {
              width: 175px;
            }
          }
        }
      }
    }
  }
}


.dialog-title {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  margin-bottom: 12px;
}
.dialog-text {
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  margin-bottom: 30px;
  color: rgba(255, 255, 255, 0.68);
}
.dialog-img {
  width: 100%;
  margin-bottom: 30px;
  img {
    width: 100%;
  }
}
.dialog-list {
  width: 100%;
  padding: 10px 0;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  line-height: 24px;
  border-radius: 20px;
  color: rgba(255, 255, 255, 0.68);
  background: rgba(143, 155, 165, 0.2);
  ul {
    li {
      margin: 5px 0;
    }
  }
}


@media screen and (max-width: 1200px) {
  .rule {
    width: 90%;
    .show {
      display: none;
    }
    .hide {
      display: block;
    }
    .rule_cont {
      .rule_list {
        .rule_li {
          width: 100%;
        }
      }
    }
  }
}
</style>